(function () {
  'use strict';

  var focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function initWithdrawal(container) {
    if (!container || container.dataset.withdrawalInitialized === 'true') {
      return;
    }

    var uniqueId = container.dataset.withdrawalId;
    var modalId = container.dataset.modalId;

    if (!uniqueId || !modalId || typeof window.MicroModal === 'undefined') {
      return;
    }

    container.dataset.withdrawalInitialized = 'true';

    window.MicroModal.init({
      disableScroll: true,
      openTrigger: 'data-popup-' + uniqueId,
      onShow: function (modal) {
        var firstFocus = modal.querySelector(focusableSelector);
        if (firstFocus) {
          firstFocus.focus();
        }
      },
    });

    if (container.dataset.formReopen === 'true') {
      window.MicroModal.show(modalId);
    }
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-withdrawal]').forEach(initWithdrawal);
  }

  if (document.readyState === 'complete') {
    initAll(document);
  } else {
    window.addEventListener('load', function () {
      initAll(document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
